<template>
  <div class="backdrop main-Product" id="main-ProductDisplay">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: "productDisplay",
  }
</script>

<style scoped>
  #paging{
    margin: auto;
    width: 50%;
    border: 1px solid #f8f8f8;
  }
  .introduce {
    width: 400px;
    text-align: center;
    margin: 10px auto;
    font-size: 0.1rem;
  }

  /*产品展示开始*/
  .main-Product{
    background-image: url(../assets/img/pic/pic_PRODUCT.jpg);
    /*background-repeat:no-repeat;*/
  }
  .product-display{
    margin: .3rem .7rem ;
    display: flex;
  }
  .product-display>div{
    width: 100%;
    text-align: center;
    flex-grow: 1;
    margin: .1rem;
    transition: all 0.5s;
    background-color: #fff;
    /*padding-bottom: 0.8rem;*/
    /*height: 4rem;*/
    padding-bottom:0.2rem ;
  }
  .product-display>div:hover{
    cursor: pointer;
    transform: translate(0,-5px);
    box-shadow: 0 0 30px 0 #B0B0B0;
  }
  .product-display>div img{
    width: 100%;
    height: 2rem;
  }
  .product-display>div p:nth-child(2){
    font-size: 0.3rem;
    color: #333;
  }
  .product-display>div p:nth-child(3){
    font-size: 0.12rem;
    color: #b0b0b0;
    margin: 0.2rem auto 0;
    text-align: left;
    padding: 0 10px;
    display: -webkit-box;
    /*-webkit-line-clamp: 8;*/
    /*-webkit-box-orient: vertical;*/
    overflow: hidden;
  }
  /*产品展示结束*/
  @media screen and (max-width: 1024px) {
  }

  @media screen and (max-width: 768px) {
    #paging{
      width: 100%;
    }
    .introduce {
      width: 12rem;
      font-size: 0.4rem;
    }
    /* 产品展示 */
    .product-display{
      flex-wrap:wrap;
    }
    .product-display>div{
      width: 7rem;
    }
    .product-display>div:hover{
      cursor: pointer;
      transform: translate(0,0);
      box-shadow: 0 0 0 0 #B0B0B0;
    }
    .product-display>div img{
      height: 4rem;
    }
    .product-display>div p:nth-child(2){
      font-size: 16px;
    }
    .product-display>div p:nth-child(3){
      font-size: 14px;
      display: -webkit-box;
      /*-webkit-line-clamp: 4;*/
      /*-webkit-box-orient: vertical;*/
      overflow: hidden;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/productDisplay.vue